import { FluidKeyedObject } from '@lmig/fluid-core';

export enum FluidCurrencyCode {
  USD = 'USD',
  GBR = 'GBR',
  CAD = 'CAD',
  AUD = 'AUD',
  EUR = 'EUR',
  JPY = 'JPY',
  NZD = 'NZD',
  HKD = 'HKD',
  SGD = 'SGD',
  DKK = 'DKK',
}

export const fluidCurrencyLocales: FluidKeyedObject<{
  name: string;
  locale: string;
  currencyCode: string;
}> = {
  USD: { name: 'US Dollar', locale: 'en-US', currencyCode: 'USD' },
  GBR: { name: 'British Pounds', locale: 'en-UK', currencyCode: 'GBP' },
  CAD: { name: 'Canadian Dollar', locale: 'en-CA', currencyCode: 'CAD' },
  AUD: { name: 'Australian Dollar', locale: 'en-AU', currencyCode: 'AUD' },
  EUR: { name: 'Euros', locale: 'en-IE', currencyCode: 'EUR' },
  JPY: { name: 'Japanese Yen', locale: 'ja-JP', currencyCode: 'JPY' },
  NZD: { name: 'New Zealand Dollar', locale: 'en-NZ', currencyCode: 'NZD' },
  HKD: { name: 'Hong Kong Dollar', locale: 'zh-HK', currencyCode: 'HKD' },
  SGD: { name: 'Singapore Dollar', locale: 'zh-SG', currencyCode: 'SGD' },
  DKK: { name: 'Danish Krone', locale: 'da-DK', currencyCode: 'DKK' },
};
